"use client";

import { useEffect, useRef } from "react";
import { GetFoldersResponseType } from "./useGetFolders";

/** Mirrors the current folder into the `folderId` search param (shallow, no
 *  server round-trip) so a refresh reopens the same folder. */
export function useSyncFolderIdToUrl(
    enabled: boolean,
    parentFolder: GetFoldersResponseType["data"][0] | null
) {
    // The first render still has parentFolder=null while the initial
    // ?folderId is being applied — touching the URL then would erase it.
    const isInitialRender = useRef(true);

    useEffect(() => {
        if (!enabled) return;
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }

        const url = new URL(window.location.href);
        if (parentFolder) {
            url.searchParams.set("folderId", parentFolder.id);
        } else {
            url.searchParams.delete("folderId");
        }
        window.history.replaceState(null, "", url);
    }, [enabled, parentFolder]);
}
